import { Description, Tooltip, useListItem } from '@sparemin/blockhead';
import cn from 'classnames';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  makeProjectNameSelector,
  makeProjectReprAtSelector,
  makeProjectWidgetUuidSelector,
} from 'redux/modules/entities';

import { ProjectTileControl } from '../types';
import { block } from '../utils';
import ProjectRowActions from './ProjectRowActions';
import { ProjectRowProvider } from './ProjectRowContext';
import ProjectRowHeadline from './ProjectRowHeadline';
import ProjectRowThumbnail from './ProjectRowThumbnail';

export interface ProjectRowProps {
  projectId?: string;
  tooltipMessage?: string;
  headerClassName?: string;
  onControlClick?: (type: ProjectTileControl, projectId: string) => void;
}

const ProjectRow: React.FC<ProjectRowProps> = ({
  projectId,
  tooltipMessage,
  headerClassName,
  onControlClick,
}) => {
  const { isDisabled } = useListItem();

  const reprAt = useSelector(
    useMemo(() => makeProjectReprAtSelector(projectId), [projectId]),
  );
  const projectName = useSelector(
    useMemo(() => makeProjectNameSelector(projectId), [projectId]),
  );
  const widgetId = useSelector(
    useMemo(() => makeProjectWidgetUuidSelector(projectId), [projectId]),
  );

  return (
    <ProjectRowProvider projectId={projectId}>
      <Tooltip
        contents={tooltipMessage}
        isDisabled={!isDisabled}
        placement="top"
        arrow
      >
        <Description
          isDisabled={isDisabled}
          className={block('project-row', { disabled: isDisabled })}
        >
          <Description.Header className={cn(block('header'), headerClassName)}>
            <ProjectRowThumbnail />

            <ProjectRowHeadline {...{ projectName, reprAt }} />

            <ProjectRowActions {...{ widgetId, onControlClick }} />
          </Description.Header>
        </Description>
      </Tooltip>
    </ProjectRowProvider>
  );
};

export default ProjectRow;
